exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".primary-menu-config[data-v-d5f80932]{padding:20px}.primary-menu-config .header-actions[data-v-d5f80932]{margin-bottom:16px}.primary-menu-config .divider[data-v-d5f80932]{color:#dcdfe6;margin:0 8px}.primary-menu-config .action-buttons[data-v-d5f80932]{margin-top:24px;text-align:center}.primary-menu-config .action-buttons .el-button[data-v-d5f80932]{margin:0 10px;padding:10px 30px}.dialog-footer .el-button[data-v-d5f80932]{padding:10px 20px}", ""]);

// exports
